let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useTheme } from 'foundations-theming/utils';

// Some nested foundations-components (e.g. the date picker's day cells and
// weekday headers) style text with raw styled-components that omit `fontFamily`,
// so they don't pick up the brand font and fall back to the default. Set the
// brand body font as the document base font so that inherited text uses it.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalFontOverrides = createGlobalStyle(_t || (_t = _`
  body {
    font-family: ${0} !important;
  }
`), ({
  $bodyFontFamily
}) => $bodyFontFamily);
export const GlobalFontStyles = () => {
  var _theme$typography$bod;
  const theme = useTheme();
  // All body tokens are set to the same font family, so body-200 is just a
  // representative choice here — nothing special about it.
  const bodyFontFamily = (_theme$typography$bod = theme.typography['body-200']) === null || _theme$typography$bod === void 0 ? void 0 : _theme$typography$bod.fontFamily;
  if (!bodyFontFamily) return null;
  return /*#__PURE__*/_jsx(StyledGlobalFontOverrides, {
    $bodyFontFamily: bodyFontFamily
  });
};